/*
 * @Author: your name
 * @Date: 2021-03-18 11:55:12
 * @LastEditTime: 2021-08-17 09:17:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ycfsite-vue\src\routel.js
 */
	export default {
		url:"https://smis.cn",
		// url:"https://smis.cn/SmisSaasServer",

	}



// WEBPACK FOOTER //
// ./src/routel.js